module.exports = __webpack_public_path__ + "img/cruze-19.2cbf6345.png";